// extracted by mini-css-extract-plugin
export default {"reportSettings":"reportSettings-QqFhW","container":"container-e1SXV","filters":"filters-PEA6O","checkbox":"checkbox-nlau0","bold":"bold-quDXn","checkboxTitle":"checkboxTitle-FXJpQ"};